import React, { useState } from 'react';
import './BulkCardOperations.css';

export const BulkCardOperations = ({
  deckName,
  cards,
  allDecks,
  isCustomDeck,
  onBulkDelete,
  onBulkTag,
  onBulkMoveToDeck,
  onClose
}) => {
  const [selectedCards, setSelectedCards] = useState(new Set());
  const [selectAll, setSelectAll] = useState(false);
  const [operation, setOperation] = useState('');
  const [newTag, setNewTag] = useState('');
  const [targetDeck, setTargetDeck] = useState('');

  const toggleCard = (index) => {
    const newSelected = new Set(selectedCards);
    if (newSelected.has(index)) {
      newSelected.delete(index);
    } else {
      newSelected.add(index);
    }
    setSelectedCards(newSelected);
    setSelectAll(newSelected.size === cards.length);
  };

  const toggleSelectAll = () => {
    if (selectAll) {
      setSelectedCards(new Set());
    } else {
      setSelectedCards(new Set(cards.map((_, i) => i)));
    }
    setSelectAll(!selectAll);
  };

  const handleBulkDelete = () => {
    if (selectedCards.size === 0) return;

    if (window.confirm(`Delete ${selectedCards.size} selected cards?`)) {
      onBulkDelete(Array.from(selectedCards));
      setSelectedCards(new Set());
      setSelectAll(false);
    }
  };

  const handleBulkTag = () => {
    if (selectedCards.size === 0 || !newTag.trim()) return;

    onBulkTag(Array.from(selectedCards), newTag.trim());
    setNewTag('');
    setSelectedCards(new Set());
    setSelectAll(false);
  };

  const handleBulkMove = () => {
    if (selectedCards.size === 0 || !targetDeck) return;

    if (window.confirm(`Move ${selectedCards.size} cards to "${targetDeck}"?`)) {
      onBulkMoveToDeck(Array.from(selectedCards), targetDeck);
      setSelectedCards(new Set());
      setSelectAll(false);
      setTargetDeck('');
    }
  };

  const customDecks = Object.keys(allDecks).filter(name =>
    name !== deckName && allDecks[name] !== undefined
  );

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="bulk-operations" onClick={(e) => e.stopPropagation()}>
        <div className="bulk-operations-header">
          <h2>Bulk Operations - {deckName}</h2>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>

        <div className="bulk-operations-content">
          {/* Selection Controls */}
          <div className="bulk-selection-controls">
            <label className="bulk-checkbox-label">
              <input
                type="checkbox"
                checked={selectAll}
                onChange={toggleSelectAll}
              />
              <span>Select All ({cards.length} cards)</span>
            </label>
            <div className="bulk-selected-count">
              {selectedCards.size} card{selectedCards.size !== 1 ? 's' : ''} selected
            </div>
          </div>

          {/* Cards List */}
          <div className="bulk-cards-list">
            {cards.map((card, index) => (
              <div
                key={index}
                className={`bulk-card-item ${selectedCards.has(index) ? 'selected' : ''}`}
              >
                <input
                  type="checkbox"
                  checked={selectedCards.has(index)}
                  onChange={() => toggleCard(index)}
                  className="bulk-card-checkbox"
                />
                <div className="bulk-card-content">
                  <div className="bulk-card-ar">{card.ar}</div>
                  <div className="bulk-card-en">{card.en}</div>
                  {card.tags && card.tags.length > 0 && (
                    <div className="bulk-card-tags">
                      {card.tags.map((tag, i) => (
                        <span key={i} className="bulk-card-tag">{tag}</span>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>

          {/* Operations Panel */}
          <div className="bulk-operations-panel">
            <h3>Bulk Operations</h3>

            {/* Tag Operation */}
            <div className="bulk-operation-section">
              <h4>Add Tag to Selected Cards</h4>
              <div className="bulk-operation-controls">
                <input
                  type="text"
                  className="bulk-input"
                  placeholder="Tag name..."
                  value={newTag}
                  onChange={(e) => setNewTag(e.target.value)}
                  onKeyPress={(e) => e.key === 'Enter' && handleBulkTag()}
                />
                <button
                  className="bulk-action-btn"
                  onClick={handleBulkTag}
                  disabled={selectedCards.size === 0 || !newTag.trim()}
                >
                  Add Tag ({selectedCards.size})
                </button>
              </div>
            </div>

            {/* Move Operation */}
            {customDecks.length > 0 && isCustomDeck && (
              <div className="bulk-operation-section">
                <h4>Move to Another Deck</h4>
                <div className="bulk-operation-controls">
                  <select
                    className="bulk-select"
                    value={targetDeck}
                    onChange={(e) => setTargetDeck(e.target.value)}
                  >
                    <option value="">Select deck...</option>
                    {customDecks.map(deck => (
                      <option key={deck} value={deck}>{deck}</option>
                    ))}
                  </select>
                  <button
                    className="bulk-action-btn"
                    onClick={handleBulkMove}
                    disabled={selectedCards.size === 0 || !targetDeck}
                  >
                    Move ({selectedCards.size})
                  </button>
                </div>
              </div>
            )}

            {/* Delete Operation */}
            {isCustomDeck && (
              <div className="bulk-operation-section bulk-delete-section">
                <h4>Delete Selected Cards</h4>
                <button
                  className="bulk-delete-btn"
                  onClick={handleBulkDelete}
                  disabled={selectedCards.size === 0}
                >
                  🗑️ Delete ({selectedCards.size}) Cards
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
